import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Typography, Button, Container } from '@mui/material';

function CTA() {
  return (
    <Box
      sx={{
        background: 'linear-gradient(135deg, #111111 0%, #050505 100%)',
        borderTop: '1px solid rgba(212, 175, 55, 0.15)',
        borderBottom: '1px solid rgba(212, 175, 55, 0.15)',
        py: { xs: 8, md: 12 },
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: '-50%',
          left: '-50%',
          width: '200%',
          height: '200%',
          background: 'radial-gradient(circle, rgba(212, 175, 55, 0.05) 0%, transparent 60%)',
        },
      }}
    >
      <Container maxWidth="md" sx={{ position: 'relative', zIndex: 10 }}>
        <Typography
          variant="h2"
          component="h2"
          sx={{
            fontFamily: "'Playfair Display', serif",
            color: '#ffffff',
            mb: 3,
            fontSize: { xs: '2.5rem', md: '3.5rem' },
          }}
        >
          Ready to Invest in the Future?
        </Typography>
        
        <Typography
          variant="body1"
          sx={{
            color: '#a1a1a1',
            mb: 5,
            maxWidth: '600px',
            mx: 'auto',
            lineHeight: 1.8,
          }}
        >
          Our specialists are ready to guide you through exclusive acquisitions 
          tailored to your financial goals.
        </Typography>

        <Button
          component={RouterLink}
          to="/contact"
          variant="contained"
          sx={{
            bgcolor: '#d4af37',
            color: '#000000',
            fontWeight: 700,
            fontSize: '0.85rem',
            letterSpacing: '2px',
            textTransform: 'uppercase',
            padding: '18px 45px',
            borderRadius: 0,
            '&:hover': {
              bgcolor: '#e8c84a',
              boxShadow: '0 10px 30px rgba(212, 175, 55, 0.3)',
              transform: 'translateY(-2px)',
            },
            transition: 'all 0.4s ease',
          }}
        >
          Contact Our Specialists
        </Button>
      </Container>
    </Box>
  );
}

export default CTA;